import Api from '@/lib/api/api';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/profile.hbs';
import ide_settings from '@/models/ide_settings';
var globalCh = Radio.channel('global');

var ProfileView = Marionette.View.extend({
    template: Handlebars.compile(template),
    regions: {
        device_count: '.device-count',
        deployed_build: '.deployed-build'
    },
    tagName: 'div',
    className: 'standard-layout',
    ui: {
        username: '.username',
        email: '.email',
        change_email: '.change_email',
        password: '.password',
        change_password: '.change_password',
        account_details: '.account-details',
        time_zone: '.time-zone',
        selected_time_zone: '.selected-time-zone'
    },
    events: {
        'click @ui.change_password': 'show_change_password',
        'click @ui.change_email': 'show_change_email',
        'click @ui.account_details': 'show_account_details',
        'click @ui.time_zone': 'show_time_zone_options',
    },
    modelEvents: {
        'change': 'render'
    },
    initialize: function() {
      this.app_features = globalCh.request('app_options', 'features');
    },
    templateContext: function () {
        var globalCh = Radio.channel('global');
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        var is_self = active === primary;
        return {
            is_self: is_self,
        };
    },
    onRender: function() {
        ide_settings.fetch().done(this.show_user_timezone);
    },
    show_user_timezone: function() {
            var primary = globalCh.request('primary_account');
            var timezone = primary.get_timezone();
            return $("#selected-time-zone").val(timezone);
    },
    show_change_password: function () {
        globalCh.request('show_change_password_dialog', this.model);
    },
    show_change_email: function(){
        globalCh.request('show_change_email_dialog', this.model);
    },
    show_account_details: function(){
        globalCh.request('show_change_account_details_dialog', this.model);
    },
    show_time_zone_options: function(e){
        e.preventDefault();
        globalCh.request('show_time_zone_options_dialog', this.model);
    },
});

export default ProfileView;
